<nav class="bg-light navbar w-100 justify-content-center sticky-top">
  <div
    class="container-fluid d-flex align-items-center justify-content-between m-0"
  >
    <div>
      <!--h3 class="h3 text-center titleFont">{{this.title}}</h3-->
      <h2 class="h2 m-2">{{ this.title }}</h2>
    </div>
    <button
      (click)="open(sidebar)"
      role="button"
      class="navbar-brand btn d-inline-block align-text-top m-0"
    >
      <svg
        class="menu-icon align-middle"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            d="M4 6H20M4 12H20M4 18H20"
            stroke="#3880ff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </g>
      </svg>
    </button>
  </div>
</nav>
<div class="d-flex justify-content-center d-none">
  <img
    src="/assets/283.png"
    width="233"
    height="233"
    alt="Icon of 283 production"
    class="img-fluid"
  />
</div>
<ng-template #sidebar let-offcanvas>
  <div class="offcanvas-header p-3">
    <div class="container d-flex align-items-center justify-content-between">
      <h3 class="h3 m-0">동네빵집</h3>
      <button
        role="button"
        class="btn p-0"
        aria-label="Close"
        (click)="offcanvas.dismiss()"
      >
        <svg
          class="menu-icon align-middle"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
              fill="#3880ff"
            ></path>
          </g>
        </svg>
      </button>
    </div>
  </div>
  <div class="offcanvas-body" style="background-color: #34eb3a">
    <nav class="nav">
      <a class="nav-link" [routerLink]="['/']" (click)="offcanvas.dismiss()"
        >홈페이지</a
      >
      <a
        class="nav-link"
        [routerLink]="['/timetable']"
        (click)="offcanvas.dismiss()"
        >히스토리</a
      >
      <a
        class="nav-link"
        [routerLink]="['/cardle']"
        (click)="offcanvas.dismiss()"
        >카드게임</a
      >
      <a
        class="nav-link"
        [routerLink]="['/r-lookup']"
        (click)="offcanvas.dismiss()"
        >스킬체크</a
      >
    </nav>
    <nav class="nav flex-column">
      <app-charlist (idolClicked)="onCharlistClick($event)"></app-charlist>
    </nav>
    <!--app-settings></app-settings-->

    <div class="d-flex justify-content-evenly pb-3">
      <a
        href="http://bbang.shinymaskr.work"
        target="_blank"
        class="text-decoration-none"
      >
        <div
          class="d-flex justify-content-center align-items-center bg-white rounded-circle"
          style="
            width: 40px;
            height: 40px;
            font-weight: bold;
            color: #000;
            font-size: 10px;
          "
        >
          스파인
        </div>
      </a>
      <a
        href="https://shinycolors.info/"
        target="_blank"
        rel="noopener noreferrer"
        class="text-decoration-none"
      >
        <div
          class="d-flex justify-content-center align-items-center bg-white rounded-circle"
          style="
            width: 40px;
            height: 40px;
            font-weight: bold;
            color: #000;
            font-size: 10px;
          "
        >
          위키
        </div>
      </a>
      <a
        href="https://shiny4ko.netlify.app"
        target="_blank"
        class="text-decoration-none"
      >
        <div
          class="d-flex justify-content-center align-items-center bg-white rounded-circle"
          style="
            width: 40px;
            height: 40px;
            font-weight: bold;
            color: #000;
            font-size: 10px;
          "
        >
          4컷
        </div>
      </a>
      <a
        href="https://github.com/ShinyColorsDB/ShinyColorsDB-DataSite"
        target="_blank"
        class="text-decoration-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          width="40"
          height="40"
          viewBox="0 0 256 256"
          xml:space="preserve"
        >
          <defs></defs>
          <g
            style="
              stroke: none;
              stroke-width: 0;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-linejoin: miter;
              stroke-miterlimit: 10;
              fill: none;
              fill-rule: nonzero;
              opacity: 1;
            "
            transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
          >
            <path
              d="M 45 0 C 20.147 0 0 20.467 0 45.714 C 0 67.034 14.367 84.944 33.802 90 c -0.013 -5.283 -0.03 -11.763 -0.04 -13.782 c -12.986 2.869 -15.726 -5.595 -15.726 -5.595 c -2.123 -5.481 -5.183 -6.939 -5.183 -6.939 c -4.236 -2.943 0.319 -2.883 0.319 -2.883 c 4.687 0.334 7.156 4.887 7.156 4.887 c 4.163 7.249 10.92 5.153 13.584 3.942 c 0.419 -3.064 1.628 -5.157 2.964 -6.341 c -10.368 -1.199 -21.268 -5.265 -21.268 -23.435 c 0 -5.177 1.824 -9.407 4.81 -12.728 c -0.485 -1.195 -2.083 -6.018 0.452 -12.55 c 0 0 3.92 -1.274 12.84 4.861 c 3.724 -1.051 7.717 -1.578 11.684 -1.596 c 3.967 0.018 7.963 0.545 11.694 1.596 c 8.91 -6.135 12.824 -4.861 12.824 -4.861 c 2.541 6.532 0.943 11.355 0.458 12.55 c 2.993 3.321 4.804 7.551 4.804 12.728 c 0 18.214 -10.92 22.223 -21.315 23.398 c 1.674 1.472 3.166 4.357 3.166 8.781 c 0 3.513 -0.016 11.601 -0.031 17.74 C 76.021 84.439 90 66.74 90 45.714 C 90 20.467 69.853 0 45 0 z"
              style="
                stroke: none;
                stroke-width: 1;
                stroke-dasharray: none;
                stroke-linecap: butt;
                stroke-linejoin: miter;
                stroke-miterlimit: 10;
                fill: rgb(0, 0, 0);
                fill-rule: nonzero;
                opacity: 1;
              "
              transform=" matrix(1 0 0 1 0 0) "
              stroke-linecap="round"
            />
          </g>
        </svg>
      </a>
    </div>
  </div>
</ng-template>

<!--template>
  <div ngbAccordion>
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>ShinyColorsDB</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <div class="list-group">
            <a
              class="text-start list-group-item list-group-item-action w-100 ps-4 bg-light bg-gradient"
              [routerLink]="['/']"
              (click)="onSideBarClick()" i18n>首頁</a>
            <a
              class="text-start list-group-item list-group-item-action w-100 ps-4 bg-light bg-gradient"
              [routerLink]="['/timetable']"
              (click)="onSideBarClick()" i18n>歴史</a>
            <a
              class="text-start list-group-item list-group-item-action w-100 ps-4 bg-light bg-gradient"
              [routerLink]="['/cardle']"
              (click)="onSideBarClick()">Cardle</a>
            <a
              class="text-start list-group-item list-group-item-action w-100 ps-4 bg-light bg-gradient"
              [routerLink]="['/r-lookup']"
              (click)="onSideBarClick()" i18n>技能篩選</a>
          </div>
        </div>
      </div>
    </div>
    <div ngbAccordionItem cardClass="p-0" [collapsed]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>角色列表</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <app-charlist
            (idolClicked)="onCharlistClick($event)"
            [isBigScreen]="this.isBigScreen"></app-charlist>
        </div>
      </div>
    </div>
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>其他小玩具</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <div class="list-group">
            <a
              href="https://sfp.shinycolors.moe/"
              class="text-start list-group-item list-group-item-action w-100 ps-4 bg-light bg-gradient"
              target="_blank">
              Song for Prism 資料庫
            </a>
            <a
              href="https://spine.shinycolors.moe/"
              class="text-start list-group-item list-group-item-action w-100 ps-4 bg-light bg-gradient"
              target="_blank">
              SpineViewer
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template-->
